<template>
  <div class="lg:ml-2 lg:mt-6 xl:ml-2 xl:mt-6 p-2 bg-gray-200 shadow-md">
    <div
      class="flex flex-row cursor-pointer border-b border-gray-400 py-2"
      @click="loadPage('EditUsers')"
    >
      <i class="material-icons md-3xl mr-2">groups</i>
      <p>Gebruikers</p>
    </div>

    <div
      class="flex flex-row cursor-pointer border-b border-gray-400 py-2"
      @click="loadPage('EditRoles')"
    >
      <i class="material-icons md-3xl mr-2">supervised_user_circle</i>
      <p>Rollen</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminMenu",
  methods: {
    loadPage: function(page) {
      this.$router.push({ name: page });
    }
  }
};
</script>

<style></style>
